const emptyWallet = () => ({ address: '', balances: [], connected: false, accountIndex: 0 });

export default {
  namespaced: true,
  state: () => ({
    tron:     emptyWallet(),
    solana:   emptyWallet(),
    ethereum: emptyWallet(),
    bsc:      emptyWallet(),
    polygon:  emptyWallet(),
    bitcoin:  emptyWallet(),
  }),
  mutations: {
    SET_WALLET(state, { chain, data }) {
      if (state[chain]) Object.assign(state[chain], data);
    },
  },
  getters: {
    allBalances(state) {
      const result = [];
      for (const [chain, wallet] of Object.entries(state)) {
        if (wallet.connected) {
          for (const b of wallet.balances) result.push({ ...b, chain });
        }
      }
      return result;
    },
    connectedChains(state) {
      return Object.entries(state)
        .filter(([, w]) => w.connected)
        .map(([chain]) => chain);
    },
  },
};
